module.exports = __webpack_public_path__ + "img/PV_logo.0f433671.png";